import React, { ComponentProps, ReactNode } from 'react';

import classNames from 'classnames';

import classes from './SelectableCard.module.scss';

type SelectableCardProps = {
  variant?: 'inBox' | 'outBox';
  className?: string;
  children: ReactNode;
  dataTestId?: string;
} & ComponentProps<'label'>;

/**
 * Label wrapper for radio/checkbox cards with automatic border styling on hover and checked states.
 * Radio or checkbox should be the child.
 * Display, width, height, padding or inner content position should be handled by the parent styles.
 *
 * Uses CSS `:has()` to auto-detect checked state - no need to pass `checked` prop.
 *
 * See stories for examples.
 */
const SelectableCard = ({
  className,
  children,
  dataTestId,
  variant = 'inBox',
  ...props
}: SelectableCardProps) => {
  const containerClasses = classNames(classes.container, className, classes[variant]);

  return (
    <label className={containerClasses} data-test-id={dataTestId} {...props}>
      {children}
    </label>
  );
};

export { SelectableCard };
